module.exports = __webpack_public_path__ + "img/multimediaelektroniker_n_m_3466.1d80ff17.jpg";